import React from "react";
import { BRILLO_LOGO_URL } from "@/lib/api";

export default function BrilloLogo({ className = "h-10 w-auto", alt = "Brillo Finance" }) {
  return (
    <img
      src={BRILLO_LOGO_URL}
      alt={alt}
      className={className}
      data-testid="brillo-logo"
      draggable={false}
    />
  );
}
